define('util/presenceMetaData',[
    'lib/knockout',
    'lib/lodash4',
], function (
    ko,
    _
) {
    'use strict';

    var STATUS_TYPES = {
        AVAILABLE:      "userStatus-available",
        AWAY:           "userStatus-away",
        BREAK:          "userStatus-break",
        BUSY:           "userStatus-busy",
        IDLE:           "userStatus-idle",
        MEAL:           "userStatus-meal",
        MEETING:        "userStatus-meeting",
        OFFLINE:        "userStatus-offline",
        ON_QUEUE:       "userStatus-on-queue",
        TRAINING:       "userStatus-training"
    };

    // Define metadata attributes for each status
    var STATUS_METADATA = {};


    STATUS_METADATA.AVAILABLE = {
        id: '6a3af858-942f-489d-9700-5f9bcdcdae9b',
        label: 'userStatus.available',
        icon: '',
        type: STATUS_TYPES.AVAILABLE,
        value: 'available'
    };

    STATUS_METADATA.AWAY = {
        id: '5e5c5c66-ea97-4e7f-ac41-6424784829f2',
        label: 'userStatus.away',
        icon: '',
        type: STATUS_TYPES.AWAY,
        value: 'away'
    };

    STATUS_METADATA.BREAK = {
        id: '227b37e2-f1d0-4dd0-8f50-badd7cf6d158',
        label: 'userStatus.break',
        icon: '',
        type: STATUS_TYPES.BREAK,
        value: 'break'
    };

    STATUS_METADATA.BUSY = {
        id: '31fe3bac-dea6-44b7-bed7-47f91660a1a0',
        label: 'userStatus.busy',
        icon: '',
        type: STATUS_TYPES.BUSY,
        value: 'busy'
    };

    STATUS_METADATA.IDLE = {
        id: '7ffa01cd-7866-4ad7-8faa-31e11b42f51f',
        label: 'userStatus.idle',
        icon: '',
        type: STATUS_TYPES.IDLE,
        value: 'idle'
    };

    STATUS_METADATA.MEAL = {
        id: '3fd96123-badb-4f69-bc03-1b1ccc6d8014',
        label: 'userStatus.meal',
        icon: '',
        type: STATUS_TYPES.MEAL,
        value: 'meal'
    };

    STATUS_METADATA.MEETING = {
        id: 'bbdff279-7ae1-48ea-bade-7831d7234c64',
        label: 'userStatus.meeting',
        icon: '',
        type: STATUS_TYPES.MEETING,
        value: 'meeting'
    };

    STATUS_METADATA.OFFLINE = {
        id: 'ccf3c10a-aa2c-4845-8e8d-f59fa48c58e5',
        label: 'userStatus.offline',
        icon: '',
        type: STATUS_TYPES.OFFLINE,
        value: 'offline'
    };

    STATUS_METADATA.TRAINING = {
        id: 'd2390a99-8546-bad9-8f0a-219548e8aeb0',
        label: 'userStatus.training',
        icon: '',
        type: STATUS_TYPES.TRAINING,
        value: 'training'
    };

    STATUS_METADATA.ON_QUEUE = {
        id: 'e08eaf1b-ee47-4fa9-a231-1200e284798f',
        label: 'userStatus.onQueue',
        icon: '',
        type: STATUS_TYPES.ON_QUEUE,
        value: 'on queue'
    };

    /**
     * A listing of date/time moment.js format strings used throughout the
     * client to make it easy to swap/tweak formats and still maintain
     * consistancy.
     */
    var StatusMetaData = {
        findStatusById: function(statusId) {
            return _.find(STATUS_METADATA, function(item) {
                return item.id === statusId;
            });
        },

        statuses: ko.observable(STATUS_METADATA)
    };

    return StatusMetaData;
});

